import { authClient } from '@/lib/auth-client';

export const signIn = async (credentials: { email: string; password: string }) => {
  const { error: signInError } = await authClient.signIn.email({
    email: credentials.email,
    password: credentials.password,
  });

  if (signInError) {
    throw new Error(signInError.message);
  }

  const { data: session, error: sessionError } = await authClient.getSession({
    // query: { disableCookieCache: true },
  });

  if (sessionError) {
    throw new Error(sessionError.message);
  }

  return session;
};

export const forgotPassword = async (email: string) => {
  const { data, error } = await authClient.forgetPassword.emailOtp({
    email,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const verifyEmail = async ({ email, otp }: { email: string; otp: string }) => {
  const { error } = await authClient.emailOtp.verifyEmail({
    email,
    otp,
  });

  if (error) {
    throw new Error(error.message);
  }
};

export const resetPassword = async (params: {
  email: string;
  otp: string;
  newPassword: string;
}) => {
  const { data, error } = await authClient.emailOtp.resetPassword({
    email: params.email,
    otp: params.otp,
    password: params.newPassword,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const changePassword = async (params: { currentPassword: string; newPassword: string }) => {
  const { data, error } = await authClient.changePassword({
    currentPassword: params.currentPassword,
    newPassword: params.newPassword,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const resendEmailOtp = async () => {
  const { data: session, error: sessionError } = await authClient.getSession();

  if (sessionError) {
    throw new Error(sessionError.message);
  }

  if (!session?.user) {
    throw new Error('No session');
  }

  const { data, error } = await authClient.emailOtp.sendVerificationOtp({
    email: session.user.email,
    type: 'email-verification',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const fetchSession = async () => {
  const { data, error } = await authClient.getSession({
    query: { disableCookieCache: true },
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const signInWithSocial = async (params: {
  provider: 'github' | 'google';
  callbackURL?: string;
}) => {
  const { error } = await authClient.signIn.social({
    provider: params.provider,
    callbackURL: params.callbackURL || '/projects',
  });

  if (error) {
    throw new Error(error.message);
  }
};

export const signUp = async (credentials: { email: string; password: string; name: string }) => {
  const { error } = await authClient.signUp.email({
    email: credentials.email,
    password: credentials.password,
    name: credentials.name,
  });

  if (error) {
    throw new Error(error.message);
  }

  const { data: session, error: sessionError } = await authClient.getSession({
    query: { disableCookieCache: true },
  });

  if (sessionError) {
    throw new Error(sessionError.message);
  }

  return session;
};

export const updateUser = async (params: { name: string }) => {
  const { data, error } = await authClient.updateUser({
    name: params.name,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};
